module.exports = __webpack_public_path__ + "static/media/captions_Vandercook.b23a9bde.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Vandercook.vtt
// module id = 125
// module chunks = 0